import { connect } from "react-redux";
import { default as component } from "./CrowdContentOrdersReadyOrdersTable.jsx";

// global selectors and actions
import { activateModal } from "../../../common/UI/ActiveModal/duck/actions";

// local selectors and actions
import {
  getReadyForReviewCrowdContentOrdersFiltered,
  isLoading,
} from "../../duck/selectors";
import { setFocusedCrowdContentOrder } from "../modals/ReviewCrowdContentOrderModal/duck/actions";

const mapStateToProps = (state) => {
  return {
    isLoading: isLoading(state),
    contentOrders: getReadyForReviewCrowdContentOrdersFiltered(state),
  };
};

const mapDispatchToProps = {
  activateModal,
  setFocusedCrowdContentOrder,
};

export default connect(mapStateToProps, mapDispatchToProps)(component);
